import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { processRavenPayment } from "../../../../../store/modules/payments";
import { ArrowCircle, RavenIcon } from "../../../../../assets/svgIcons";

export const RecievePaymentPrompt = ({ amount = "" }) => {
  const dispatch = useDispatch();
  const { business_email } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <>
      <div>
        <div
          className={`${globalStyles.cardWithBorder} justify-content-between cursor-pointer flex-row align-items-center mb-3`}
          style={{ gap: "15px" }}
          onClick={() => {
            dispatch(
              processRavenPayment({
                business_email,
                amount: amount,
                allowFeedBack: true,
              }),
            );
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <RavenIcon />
            <div>
              <h6 className="mb-0">Use Raven Transfer</h6>
              <p className="small-text-size">
                Receive payments via raven transfer
              </p>
            </div>
          </div>
          <ArrowCircle stroke="#15112D" width="20" height="20" />
        </div>

        <div
          className={`${globalStyles.cardWithBorder} justify-content-between cursor-pointer flex-row align-items-center mb-3`}
          style={{ gap: "15px" }}
          onClick={() => {
            dispatch(
              processRavenPayment({
                amount: amount,
                allowFeedBack: true,
              }),
            );
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <RavenIcon />
            <div>
              <h6 className="mb-0">Use Raven Card Terminal</h6>
              <p className="small-text-size">
                Receive payments via raven card terminal
              </p>
            </div>
          </div>
          <ArrowCircle stroke="#15112D" width="20" height="20" />
        </div>
      </div>
    </>
  );
};
